import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { FetchAccount, FetchCompanyForAuthUser, FetchSportAuthorizations } from './auth/auth.actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class UserInitializer {
    constructor(
        private _store: Store
    ) { }

    /* APP_INITILIZER only supports Promise for now... there is a feature request opened on github
     * https://github.com/angular/angular/issues/15088
     */
    public initializeUser(): Promise<boolean> {
        return this._store.dispatch(new FetchAccount()).pipe(
            switchMap(() => this._store.dispatch([new FetchSportAuthorizations(), new FetchCompanyForAuthUser()])),
            catchError(err => of(true))
        ).toPromise();
    }
}
